export default __webpack_public_path__ + "static/media/53.650f1fac.jpg";